function accordian() {
  const accordions = document.querySelectorAll(".accordian-wrap");

  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  // Close all accordions initially
  accordions.forEach((accordion) => closeAccordion(accordion));

  // Toggle on click
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".accordian-title");
    intro.onclick = () => {
      if (accordion.classList.contains("active")) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((acc) => closeAccordion(acc));
        openAccordion(accordion);
      }
    };
  });
}

accordian();

document.addEventListener("shopify:section:load", function () {
  accordian();
});
